import React, { useMemo, useState } from 'react';
import { FaChalkboardTeacher, FaSearch } from 'react-icons/fa';

const GROUP_COLOR_COUNT = 4;
const EMPTY_LIST = [];

const groupClasses = (list) => {
  const groups = [];
  const indexByGrade = new Map();

  list.forEach((item) => {
    const separatorIndex = item.name.lastIndexOf(' - ');
    const grade = separatorIndex === -1 ? item.name : item.name.slice(0, separatorIndex);
    const section = separatorIndex === -1 ? null : item.name.slice(separatorIndex + 3);

    if (!indexByGrade.has(grade)) {
      indexByGrade.set(grade, groups.length);
      groups.push({ grade, sections: [] });
    }
    groups[indexByGrade.get(grade)].sections.push({ id: item.id, label: section || item.name });
  });

  return groups;
};

const MyClassesCard = ({ classes }) => {
  const list = classes || EMPTY_LIST;
  const [search, setSearch] = useState('');

  const filteredList = useMemo(() => {
    if (!search.trim()) return list;
    const query = search.trim().toLowerCase();
    return list.filter((item) => item.name.toLowerCase().includes(query));
  }, [list, search]);

  const groups = useMemo(() => groupClasses(filteredList), [filteredList]);

  return (
    <div className="col-xl-6 col-lg-6 col-md-12 mb-4">
      <div className="card dash-card h-100">
        <div className="dash-card-header">
          <span className="dash-card-header-title">
            <FaChalkboardTeacher />
            <span>My Classes</span>
            <span className="dash-count-pill">{list.length}</span>
          </span>
        </div>
        <div className="dash-card-body">
          <div className="dash-search-box">
            <FaSearch className="dash-search-icon" />
            <input
              type="text"
              placeholder="Search a class..."
              value={search}
              onChange={(event) => setSearch(event.target.value)}
            />
          </div>

          <div className="dash-class-groups dash-scroll-box">
            {groups.length > 0 ? (
              groups.map((group, index) => (
                <div key={group.grade} className={`dash-class-group dash-class-group-c${index % GROUP_COLOR_COUNT}`}>
                  <div className="dash-class-group-label">{group.grade}</div>
                  <div className="dash-class-group-sections">
                    {group.sections.map((section) => (
                      <span key={section.id} className="dash-section-chip">{section.label}</span>
                    ))}
                  </div>
                </div>
              ))
            ) : (
              <div className="small text-muted">No classes match "{search}".</div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MyClassesCard;
